import { UniformSlot } from "@uniformdev/canvas-react";

const UniformVariantContainer: React.FC = () => <UniformSlot name="content" />;

export default UniformVariantContainer;
